import Immutable from 'immutable';
import { createMigration } from './utils';

type TranscriptWord<TimeUnit=number> = {
    word: string;
    startTime: TimeUnit;
    endTime: TimeUnit;
};

export const migrationTo9_191 = createMigration({
    migrateVideo(video) {
        return video.withMutations(map => {
            map.get('sceneGroups').forEach((sceneGroup, i) => {
                map.setIn(['sceneGroups', i], this.migrateSceneGroup(sceneGroup));
            });
        });
    },
    migrateSceneGroup(sceneGroup) {
        return sceneGroup.withMutations(map => {
            // exit early if transcript already exists
            const words = map.getIn(['captions', 'asset', 'transcript', 'words'], []) as TranscriptWord[];
            if (words.length !== 0) {
                return map;
            }

            // create transcript from captions
            let currentStartTime = map.getIn(['mediaAsset', 'startTime'], 0) as number;
            let currentEndTime = currentStartTime;
            const transcriptWords: TranscriptWord[] = [];

            // Offset by at least 500ms to give the scene some time to animate in when scrubbed to the beginning.
            const minStartTime = 500;
            const blocks = map.getIn(['captions', 'blocks'], []) as any;
            blocks.forEach((block: any) => {
                const text = block.get('text') as string;
                const startTime = block.get('startTime') as number;
                const endTime = block.get('endTime') as number;
                const words = text.trim().replace(/\s+/g, ' ').split(' ');
                if (words.length > 0) {
                    let durationMillis = 0;
                    if (startTime < minStartTime) {
                        currentStartTime = minStartTime;
                        durationMillis = Math.max(endTime - startTime - minStartTime, 0);
                    }
                    else {
                        currentStartTime = startTime;
                        durationMillis = endTime - startTime;
                    }
                    const wordDurationMillis = Math.floor(durationMillis / words.length);
                    for (let i = 0; i < words.length; i++) {
                        currentEndTime = Math.max(currentStartTime, currentStartTime + wordDurationMillis);
                        transcriptWords.push({
                            word: words[i],
                            startTime: Math.round(currentStartTime / 100) / 10, // convert to seconds in 1 decimal place
                            endTime: Math.round(currentEndTime / 100) / 10, // convert to seconds in 1 decimal place
                        });
                        currentStartTime = currentEndTime;
                    }
                }
            });
            map.setIn(['captions', 'asset', 'transcript', 'words'], Immutable.fromJS(transcriptWords));

            const readingDirection = map.getIn(['captions', 'style', 'readingDirection'], 'ltr') as string;
            map.setIn(['captions', 'asset', 'transcript', 'textDirection'], readingDirection);
        });
    },
});
